import React, { Fragment } from 'react';
import { Container, Row, Col, Alert, ButtonGroup } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Lottie from 'lottie-react';
import Button from '../CustomButton/CustomButton';
import Card from '../Card/Card';
import LabelChargeData from '../Label/labelChargeData';
import LinearIndeterminate from '../LinearIndeterminate/LinearIndeterminate';
import loadingInit from '../../assets/json/load-fragmented-square.json';
import language from '../../config/es';

const lottieStyle = {
  flex: 1,
  height: 300,
  width: 300,
  padding: 0,
  margin: 0,
};

// Pantalla de carga inicial o de acceso restringido
export const CrudLoadingScreen = ({ msgRestricted }) => (
  <Container fluid={true}>
    <Row>
      <Col md={4}></Col>
      <Col md={4}>
        {msgRestricted !== '' ? (
          <Alert variant="danger">
            <Alert.Heading>{msgRestricted}!</Alert.Heading>
            <p>Por favor consulte con el administrador del sistema</p>
          </Alert>
        ) : (
          <Lottie style={lottieStyle} animationData={loadingInit} />
        )}
      </Col>
      <Col md={4}></Col>
    </Row>
  </Container>
);

// Botones de guardar, limpiar y recargar del formulario
export const CrudButtons = ({
  data = {},
  enable = data.enable,
  isNew = data.id === null,
  onSave,
  onClear,
  onReload,
  primary = false,
  small = true,
  reloadIcon = 'fa-repeat',
  withLoading = false,
  wrapped = false,
}) => {
  const group = (
    <ButtonGroup className="d-flex">
      <Button
        disabled={!enable}
        primary={primary}
        fill
        font_small={small}
        type="button"
        onClick={onSave}
      >
        <i className="fa fa-save"></i>{' '}
        {isNew ? language.messages.btnSave : language.messages.btnEdit}
      </Button>
      {onClear && (
        <Button
          disabled={!enable}
          info
          fill
          font_small={small}
          type="button"
          onClick={onClear}
        >
          <i className="fa fa-magnet"></i> {language.messages.btnClear}
        </Button>
      )}
      <Button
        disabled={!enable}
        warning
        fill
        font_small={small}
        type="button"
        onClick={onReload}
      >
        <i className={'fa ' + reloadIcon}></i> {language.messages.btnReload}
      </Button>
    </ButtonGroup>
  );
  return (
    <Fragment>
      {withLoading && (
        <LabelChargeData
          label={language.messages.msmRegisterDataLoading}
          showloading={enable}
        />
      )}
      {wrapped ? (
        <Row>
          <Col>{group}</Col>
        </Row>
      ) : (
        group
      )}
    </Fragment>
  );
};

// Tabla de registros con seleccion, paginacion y acciones contextuales
export const CrudDataTable = ({
  data = {},
  show = true,
  rows,
  columns = data.columns,
  onSelect,
  pending = data.pendingData,
  actions,
  clearSelected = data.showDelete,
  scrollHeight = '400px',
  paginationOptions = language.messages.paginationOptions,
  ...tableProps
}) => (
  <div className="fresh-datatables">
    {show && (
      <DataTable
        data={rows}
        columns={columns}
        fixedHeader
        fixedHeaderScrollHeight={scrollHeight}
        selectableRows
        dense
        onSelectedRowsChange={onSelect}
        highlightOnHover
        pagination
        paginationComponentOptions={paginationOptions}
        progressPending={pending}
        progressComponent={<LinearIndeterminate />}
        contextActions={actions}
        persistTableHead
        clearSelectedRows={clearSelected}
        {...tableProps}
      />
    )}
  </div>
);

// Columnas del formulario (angosta) y listado (ancha)
export const WIDE_TABLE_COLS = {
  formCol: { sm: 12, md: 5, lg: 5, xl: 4 },
  tableCol: { sm: 12, md: 7, lg: 7, xl: 8 },
};

// Estructura de dos columnas: formulario y listado
export const CrudPage = ({
  top,
  formCol,
  formIcon = ' fa fa-database',
  formTitle,
  form,
  tableCol,
  tableIcon = ' fa fa-list',
  tableClassTitle,
  tableTitle,
  table,
}) => (
  <Container fluid={true}>
    {top}
    <Row>
      <Col {...formCol}>
        <Card icono={formIcon} title={formTitle} content={form} />
      </Col>
      <Col {...tableCol}>
        <Card
          classTitle={tableClassTitle}
          icono={tableIcon}
          title={tableTitle}
          content={table}
        />
      </Col>
    </Row>
  </Container>
);
